<template>
  <ol>
    <li v-for="item in items">
      {{item}}
    </li>
  </ol>
</template>

<script>

export default {
  name: 'OrderedList',
  props: ['text', 'array'],
  data() {
    return {
    }
  },

  computed: {
    items: function () {
      if (this.array) return this.array;
      return this.text.split('\n').map(line => {
        return line.trim().replace(/^[\d]+./, '').trim();
      }).filter(line => !!line);
    }
  },

  methods: {

  },

  created() {
  }
}
</script>

<style>

</style>
